<template>
  <v-dialog
      :value="dialog"
      width="280"
      :persistent="true"
      :no-click-animation="true"
      :overlay-opacity="0.7"
      content-class="dialog-basic"
  >
    <v-card>
      <v-card-title class="flex-column mb-3">
        <v-img :src="getImage('coin.svg')"
               width="72px"
               class="chip-coin"></v-img>
        코인
      </v-card-title>
      <v-card-text>
        코인을 획득하였습니다!
      </v-card-text>
      <v-card-actions>
        <v-btn
            color="primary"
            depressed
            dark
            block
            rounded
            class="btn-basic"
            @click="close"
        >
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  computed: {
    dialog () {
      return this.$store.state.coin.coinDialog
    }
  },
  methods: {
    close () {
      this.$store.commit('onCoinModal', false)
    }
  }
}
</script>

